module.exports = __webpack_public_path__ + "img/kpmg.a2e6b1e6.png";